module.exports = __webpack_public_path__ + "static/media/hbguide-banner-mobile.d3c3bfb0.jpg";